import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Card.module.css'

/** A sheet. Most content sits in one: a title, an optional note on the right (`sub`), actions, then the content. */
export function Card(props: { title?: string; sub?: string; actions?: ReactNode; children: ReactNode; flush?: boolean }) {
  const head = props.title || props.sub || props.actions
  return (
    <section className={cx(s.card, props.flush && s.flush)}>
      {head && (
        <div className={s.head}>
          {props.title && <h2 className={s.title}>{props.title}</h2>}
          {props.sub && <span className={s.sub}>{props.sub}</span>}
          {props.actions && <div className={s.actions}>{props.actions}</div>}
        </div>
      )}
      {props.children}
    </section>
  )
}
